import React from "react";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers";
import { TextField } from "@mui/material";
import { yyyymmddGenerator } from "../Analytics/AnalyticsUtils/yyyymmddGenerator";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useAppStore } from "../../../appStore";
import { enUS, enGB } from "date-fns/locale";
import { useClipsStore } from "./ClipsStore/clipsStore";
import { useNavigate } from "react-router-dom";

export const StartDateDropDownFrontel = () => {
  const {
    userFiltersFrontel,
    setUserFiltersFrontel,
    setTimeFiltersDisabledFrontel,
  } = useClipsStore();

  const navigate = useNavigate();

  const [startTimeAnchorEl, setStartTimeAnchorEl] =
    React.useState<null | HTMLElement>(null);
  const startTimeOpen = Boolean(startTimeAnchorEl);
  const handleStartTimeClick = (event: React.MouseEvent<HTMLElement>) => {
    setStartTimeAnchorEl(event.currentTarget);
  };
  const handleStartTimeClose = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setStartTimeAnchorEl(null);
  };

  const { dateMMDDYYYY, setDateMMDDYYYY } = useAppStore();

  const selectedLocale = dateMMDDYYYY ? enUS : enGB;

  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={selectedLocale}
    >
      <DatePicker
        label={
          userFiltersFrontel.start_date ? (
            <div className="flex">
              <>Start Date</>
              <div>
                <IconButton
                  aria-label="more"
                  id="long-button-frontel-start"
                  aria-controls={
                    startTimeOpen ? "long-menu-frontel-start" : undefined
                  }
                  aria-expanded={startTimeOpen ? "true" : undefined}
                  aria-haspopup="true"
                  onClick={handleStartTimeClick}
                  sx={{
                    marginLeft: "5px",
                    padding: 0,
                    color: "#000000",
                    "&:hover": {
                      backgroundColor: "transparent",
                    },
                  }}
                >
                  <MoreVertIcon />
                </IconButton>
                <Menu
                  id="long-menu-frontel-start"
                  MenuListProps={{
                    "aria-labelledby": "long-button-frontel-start",
                  }}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  anchorEl={startTimeAnchorEl}
                  open={startTimeOpen}
                  onClose={handleStartTimeClose}
                  slotProps={{
                    paper: {
                      style: {
                        maxHeight: 48 * 4.5,
                        width: "20ch",
                      },
                    },
                  }}
                >
                  <MenuItem
                    key="mm-dd-yyyy-start-frontel"
                    onClick={(event) => {
                      setDateMMDDYYYY(true);
                      handleStartTimeClose(event);
                    }}
                  >
                    MM/DD/YYYY
                  </MenuItem>
                  <MenuItem
                    key="dd-mm-yyyy-start-frontel"
                    onClick={(event) => {
                      setDateMMDDYYYY(false);
                      handleStartTimeClose(event);
                    }}
                  >
                    DD/MM/YYYY
                  </MenuItem>
                </Menu>
              </div>
            </div>
          ) : (
            <>Start Date</>
          )
        }
        value={userFiltersFrontel.start_date}
        onChange={(newValue) => {
          if (newValue !== null) {
            setUserFiltersFrontel((previousState: any) => ({
              ...previousState,
              start_date: newValue,
            }));
          }
          if (newValue === null) {
            setUserFiltersFrontel((previousState: any) => ({
              ...previousState,
              start_date: null,
            }));
          }
          if (
            yyyymmddGenerator(newValue) !==
            yyyymmddGenerator(userFiltersFrontel.end_date)
          ) {
            setTimeFiltersDisabledFrontel(true);
            setUserFiltersFrontel((previousState: any) => ({
              ...previousState,
              start_time: null,
              end_time: null,
            }));
          }
          if (
            yyyymmddGenerator(newValue) ===
            yyyymmddGenerator(userFiltersFrontel.end_date)
          ) {
            setTimeFiltersDisabledFrontel(false);
          }
          // TODO: Add getDownloadURLFrontel call when API function is ready
          // getDownloadURLFrontel(navigate);
        }}
        renderInput={(params) => <TextField sx={{ width: 150 }} {...params} />}
      />
    </LocalizationProvider>
  );
};
